import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Button, makeStyles, Theme, Typography } from '@material-ui/core';
import { useMediaQueries } from 'hooks';
import { Plan } from 'services/quotes/types';
import RetailBestPlanCard from 'containers/retail/sections/energy-rates/RetailBestPlanCard';
import useI18n from "evcharging/hooks/useI18n";

interface SelectedPlanCardProps {
  selectedPlan: Plan;
  onChangePlan: () => void;
  onViewPlan: () => void;
}

const useStyles = makeStyles(
  (theme: Theme) => {
    return {
      mobilePlan: {
        padding: theme.spacing(1.75, 2.5),
        boxShadow: '0 3px 5px rgba(0, 0, 0, 0.05)',
        borderRadius: 6,
        marginTop: 20,
        marginBottom: -8,
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      },
      viewTitle: {
        fontSize: theme.spacing(2),
        fontWeight: 600,
        color: 'black',
      },
      viewButton: {
        padding: 2,
        lineHeight: '20px',
        fontWeight: 600,
        marginRight: -13,
      },
    };
  },
  {
    name: 'SelectedPlanCard',
  }
);

const SelectedPlanCard: React.FC<SelectedPlanCardProps> = observer((props) => {
  const { selectedPlan, onChangePlan, onViewPlan } = props;

  const { t } = useI18n();

  const isMediumUp = useMediaQueries((theme: Theme) => theme.breakpoints.up('md'));
  const classes = useStyles();

  return isMediumUp ? (
    <RetailBestPlanCard plan={selectedPlan} onSelect={onChangePlan} buttonText={'Change Plan'} />
  ) : (
    <Box className={classes.mobilePlan}>
      <Typography className={classes.viewTitle} variant={'h3'}>
        {t('rates.selected-plan')}
      </Typography>
      <Button color={'primary'} className={classes.viewButton} onClick={onViewPlan}>
        {t('action.view')}
      </Button>
    </Box>
  );
});

export default SelectedPlanCard;
